import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout';

// Pages
import Dashboard from './pages/Dashboard';
import Agents from './pages/Agents';
import CreateAgent from './pages/CreateAgent';
import AgentDetails from './pages/AgentDetails';
import Chat from './pages/Chat';
import NotFound from './pages/NotFound';

function App() {
  return (
    <AppProvider>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/agents/create" element={<CreateAgent />} />
            <Route path="/agents/:agentId" element={<AgentDetails />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/chat/:agentId" element={<Chat />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" />} />
          </Routes>
        </Layout>
      </Router>
    </AppProvider>
  );
}

export default App;
